import React from "react";
import SocialButton from "./SocialButton";
import LinktreeSvg from "../../images/icons/Linktree.svg";
import BlueskySvg from "../../images/icons/Linktree.svg";
import LinkedinSvg from "../../images/icons/Linktree.svg";
import GitlabSvg from "../../images/icons/Linktree.svg";

const linktreeClass = "social-linktree";
const blueskyClass = "social-bluesky";
const linkedinClass = "social-linkedin";
const gitlabClass = "social-gitlab";
// const twitterClass = "social-twitter";
// const instagramClass = "social-instagram";
// const facebookClass = "";
// const tumblrClass = "";
// const websiteClass = "social-website";
// const itchClass = "social-itch";
// const githubClass = "social-github";
// const twitchClass = "social-twitch";
// const patreonClass = "social-patreon";

const linktreeIcon = "fab fa-twitter";
const blueskyIcon = "fab fa-bluesky";
const linkedinIcon = "fab fa-linkedin";
const gitlabIcon = "fab fa-gitlab";
// const twitterIcon = "fab fa-twitter";
// const instagramIcon = "fab fa-instagram";
// const facebookIcon = "fab fa-facebook";
// const tumblrIcon = "fab fa-tumblr";
// const websiteIcon = "fa fa-globe"; // Regular icons still use "fa" or "fas"
// const itchIcon = "fab fa-itch-io"; // For itch.io it's "itch-io", not "gamepad"
// const githubIcon = "fab fa-github";
// const twitchIcon = "fab fa-twitch";
// const patreonIcon = "fab fa-patreon";

class SocialButtons extends React.Component {
  render() {
    const {
      linktree,
      bluesky,
      linkedin,
      instagram,
      gitlab,
      // twitter,
      // facebook,
      // tumblr,
      // website,
      // itch,
      // twitch,
      // github,
      // patreon,
    } = this.props.socialLinks;
    return (
      <div className={"pt1 pb2 " + this.props.justifyClass}>
        <SocialButton
          url={linktree}
          classes={linktreeClass}
          iconSrc={LinktreeSvg}
          altText="Linktree"
        />
        <SocialButton
          url={gitlab}
          classes={gitlabClass}
          iconSrc={GitlabSvg}
          altText="GitLab"
        />

        <SocialButton
          url={bluesky}
          classes={blueskyClass}
          iconSrc={BlueskySvg}
          altText="Bluesky"
        />

        <SocialButton
          url={linkedin}
          classes={linkedinClass}
          iconSrc={LinkedinSvg}
          altText="LinkedIn"
        />
        {/* <SocialButton url={website} classes={websiteClass} icon={websiteIcon} /> */}
        {/* <SocialButton url={gitlab} classes={gitlabClass} icon={gitlabIcon} /> */}
        {/* <SocialButton url={github} classes={githubClass} icon={githubIcon} /> */}
        {/* <SocialButton url={twitch} classes={twitchClass} icon={twitchIcon} /> */}
        {/* <SocialButton url={itch} classes={itchClass} icon={itchIcon} /> */}
        {/* <SocialButton url={patreon} classes={patreonClass} icon={patreonIcon} /> */}
        {/* <SocialButton url={twitter} classes={twitterClass} icon={twitterIcon} /> */}
        {/* <SocialButton url={bluesky} classes={blueskyClass} icon={blueskyIcon} /> */}
        {/* <SocialButton
          url={instagram}
          classes={instagramClass}
          icon={instagramIcon}
        /> */}
        {/* <SocialButton
          url={linkedin}
          classes={linkedinClass}
          icon={linkedinIcon}
        /> */}
        {/* <SocialButton
          url={facebook}
          classes={facebookClass}
          icon={facebookIcon}
        /> */}
        {/* <SocialButton url={tumblr} classes={tumblrClass} icon={tumblrIcon} /> */}
      </div>
    );
  }
}

export default SocialButtons;
